import { camelize } from '@warp-drive/utilities/string';

import { isDasherized } from './text.ts';

const KEBEB_CASE_URL_PATTERN = /\/([a-z]+(?:-[a-z]+)+)(?:\/|\?|$)/g;

// Transform kebab-case segments in the URL path to camelCase
// Match patterns like /media-images, /media-image-sizes, etc.
export function normalizeUrl(url: string): string {
  if (!url) {
    return url;
  }

  return url.replace(
    KEBEB_CASE_URL_PATTERN,
    (match: string, kebabType: string) => {
      // Only transform if this looks like a type name (has hyphens, all lowercase)
      if (isDasherized(kebabType)) {
        const camelType = camelize(kebabType);
        // Preserve the trailing slash or query string
        const trailing = match.slice(kebabType.length + 1);
        return `/${camelType}${trailing}`;
      }
      return match;
    }
  );
}
